//confirm-dialog.tsx

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useMediaQuery,
} from "@mui/material";
import React, { ReactElement } from "react";

export default function ConfirmDialog(props: {
  title: string;
  description: string | ReactElement;
  open: boolean;
  onClose: (ok?: boolean) => void;
}) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const handleCancel = () => {
    props.onClose();
  };

  const handleOk = () => {
    props.onClose(true);
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      hideBackdrop={false}
      fullScreen={false}
      maxWidth={false}
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          justifyContent: isMobile ? "flex-end" : "center",
          alignItems: isMobile ? "flex-end" : "center",
          m: 0,
        },
      }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: isMobile ? 12 : 4,
          borderTopRightRadius: isMobile ? 12 : 4,
          width: "100vw",
          maxWidth: isMobile ? "100vw" : 600,
          m: 0,
        },
      }}
    >
      <DialogTitle id="confirm-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {props.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
